import React, { useState, useEffect } from "react";
import { useUserContext } from "../../Contexts/UserContext";
import { Link } from "react-router-dom";

const ProfilePage: React.FC = () => {
    const [profilePic, setProfilePic] = useState<string>('https://via.placeholder.com/150');
    const { userData } = useUserContext();

    useEffect(() => {
        if (userData?.profileImageUrl) {
            setProfilePic(userData.profileImageUrl);
        }
    }, [userData]);

    return (
        <div className="mt-20 bg-gradient-to-r from-white to-lightbrown h-45 w-full flex items-center justify-center p-40">
            <div className="flex h-80 bg-white rounded-lg w-full gap-10 shadow-lg p-10">
                <div>
                    <img
                        src={profilePic}
                        alt="Profile"
                        className="w-50 h-60 object-cover border-4 border-gray-200"
                    />
                </div>
                <div className="flex flex-col gap-5">
                    <div className="flex gap-5">
                        <p className="font-bold">Name:</p>
                        <p>{`${userData?.firstName || ''} ${userData?.middleName || ''} ${userData?.lastName || ''}`}</p>
                    </div>
                    <div className="flex gap-5">
                        <p className="font-bold">SCN Number:</p>
                        <p>{userData?.scnNumber || 'N/A'}</p>
                    </div>
                    <div className="flex gap-5">
                        <p className="font-bold">Role:</p>
                        <p>{userData?.userRole || 'N/A'}</p>
                    </div>
                    <div className="flex gap-5">
                        <p className="font-bold">Address:</p>
                        <p>{userData?.address || 'N/A'}</p>
                    </div>
                    <div className="flex gap-5">
                        <p className="font-bold">Email:</p>
                        <p>{userData?.email || 'N/A'}</p>
                    </div>
                    <Link to='/edit-profile' className="bg-brown text-white p-3 w-fit rounded-lg">
                        Edit Profile
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;
